import TabAccounts from './TabAccounts';

export default TabAccounts;
